<template>
  <v-btn
    v-bind="$props"
    v-on="$listeners"
    icon
    plain
    @click="$emit('click:deny-item', $attrs.item)"
  >
    <slot>
      <v-icon color="orange">mdi-cancel</v-icon>
    </slot>
  </v-btn>
</template>

<script>
import { VBtn } from "vuetify/lib"

export default {
  name: "DenyItemAction",
  extends: VBtn,
}
</script>
